export default {
  title: 'Disponibilități rezervări',
};
